import React from "react";
import { Award, ArrowRight, CheckCircle2, Leaf, Mail, MapPin, Phone, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { companyInfo } from "@/mock";

function CodiceEtico() {
  return (
    <div className="min-h-screen bg-white">
      <header className="fixed top-0 w-full bg-white/95 backdrop-blur-md shadow-sm z-50 transition-all duration-300">
        <nav className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://customer-assets.emergentagent.com/job_renewable-energy-hub-19/artifacts/wxu8fra2_logo-MTSenergia-arancio-1.png.webp"
              alt="MTS Energia Logo"
              className="h-14 w-auto"
            />
          </Link>
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/#about" className="text-gray-700 hover:text-orange-600 transition-colors font-medium">
              Chi Siamo
            </Link>
            <Link to="/#divisions" className="text-gray-700 hover:text-orange-600 transition-colors font-medium">
              Servizi
            </Link>
            <Link to="/#projects" className="text-gray-700 hover:text-orange-600 transition-colors font-medium">
              Portfolio
            </Link>
            <Link to="/codice-etico" className="text-gray-700 hover:text-orange-600 transition-colors font-medium">
              Codice Etico
            </Link>
            <Link to="/#contact" className="text-gray-700 hover:text-orange-600 transition-colors font-medium">
              Contatti
            </Link>
            <Link to="/#contact">
              <Button className="bg-orange-600 hover:bg-orange-700 text-white px-6 transition-all duration-300 hover:scale-105">
                Richiedi Preventivo
              </Button>
            </Link>
          </div>
        </nav>
      </header>

      <section className="pt-32 pb-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjAzIiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-50"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <Badge className="mb-6 bg-orange-600 text-white px-4 py-2 border-0">Codice Etico</Badge>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Trasparenza ed Etica al Centro</h1>
            <p className="text-xl text-gray-300 mb-10 leading-relaxed">
              MTS Energia opera secondo i più alti standard etici, garantendo trasparenza, integrità e responsabilità sociale in ogni fase del proprio operato.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a href="https://www.mtsenergia.com/wp-content/uploads/Codice_etico.pdf" target="_blank" rel="noopener noreferrer" className="inline-block">
                <Button size="lg" className="bg-white text-gray-900 hover:bg-gray-100 px-8 py-6 text-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-2xl group">
                  <Award className="mr-2 w-5 h-5 group-hover:rotate-12 transition-transform" />
                  Scarica Codice Etico
                  <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </a>
              <Link to="/#contact" className="inline-block">
                <Button size="lg" className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-6 text-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-2xl group">
                  Contattaci <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
            </div>

            <div className="grid md:grid-cols-3 gap-6 mt-16">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <div className="w-12 h-12 bg-orange-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <CheckCircle2 className="w-6 h-6 text-white" />
                </div>
                <h3 className="font-bold text-lg mb-2">Integrità</h3>
                <p className="text-gray-300 text-sm">Onestà e trasparenza in ogni relazione</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <div className="w-12 h-12 bg-orange-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <Leaf className="w-6 h-6 text-white" />
                </div>
                <h3 className="font-bold text-lg mb-2">Sostenibilità</h3>
                <p className="text-gray-300 text-sm">Rispetto per l'ambiente e le generazioni future</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <div className="w-12 h-12 bg-orange-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <Users className="w-6 h-6 text-white" />
                </div>
                <h3 className="font-bold text-lg mb-2">Responsabilità</h3>
                <p className="text-gray-300 text-sm">Impegno sociale verso clienti e comunità</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8 mb-12">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <img
                  src="https://customer-assets.emergentagent.com/job_renewable-energy-hub-19/artifacts/wxu8fra2_logo-MTSenergia-arancio-1.png.webp"
                  alt="MTS Energia Logo"
                  className="h-12 w-auto"
                />
              </div>
              <p className="text-gray-400 text-sm leading-relaxed">
                Professionisti delle rinnovabili dal {companyInfo.foundingYear}
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-4 text-lg">Servizi</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li>
                  <Link to="/#divisions" className="hover:text-orange-400 transition-colors">
                    Operation & Maintenance
                  </Link>
                </li>
                <li>
                  <Link to="/#divisions" className="hover:text-orange-400 transition-colors">
                    Consulting
                  </Link>
                </li>
                <li>
                  <Link to="/#divisions" className="hover:text-orange-400 transition-colors">
                    Revamping
                  </Link>
                </li>
                <li>
                  <Link to="/#divisions" className="hover:text-orange-400 transition-colors">
                    Costruzioni
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4 text-lg">Azienda</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li>
                  <Link to="/#about" className="hover:text-orange-400 transition-colors">
                    Chi Siamo
                  </Link>
                </li>
                <li>
                  <Link to="/#projects" className="hover:text-orange-400 transition-colors">
                    Portfolio
                  </Link>
                </li>
                <li>
                  <Link to="/#contact" className="hover:text-orange-400 transition-colors">
                    Contatti
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4 text-lg">Contatti</h4>
              <ul className="space-y-3 text-gray-400 text-sm">
                <li className="flex items-center gap-2">
                  <Phone className="w-4 h-4" />
                  {companyInfo.phone}
                </li>
                <li className="flex items-center gap-2">
                  <Mail className="w-4 h-4" />
                  {companyInfo.email}
                </li>
                <li className="flex items-center gap-2">
                  <MapPin className="w-4 h-4" />
                  Cassino (FR)
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-gray-400 text-sm">
                © {new Date().getFullYear()} {companyInfo.legalName} - P.IVA: {companyInfo.vat}
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default CodiceEtico;
